import React, {useContext, useState} from "react";
import {forms} from "../forms";
import {MtplQuotation, Quotation} from "../../../model/quotation";
import {StepProps} from "../step-props";
import config from "../../../config";
import {Stage} from "../../../api/model/scenario";
import {ScenarioContext} from "../../../contexts/ScenarioContext";
import {StepContext} from "../../../contexts/StepContext";
import {ScenarioHeader} from "../../../components/Scenario/Header";
import {strings} from "../../../strings/strings";
import {StepInformMessageDialog} from "../other/StepInformMessageDialog";

export const GreenPersonalInfoStep = ({step}: StepProps) => {
    const {currentStep, backStageHandler} = useContext(ScenarioContext);
    const {nextStepListener, backStepListener} = useContext(StepContext);

    const onFormSubmit = (submittedQuotation: MtplQuotation) => {
        nextStepListener(submittedQuotation);
    };

    const backStepHandler = (quotation: Quotation) => {
        backStepListener(quotation, (stage: Stage) => {
            const currentStepIndex = stage.steps.indexOf(currentStep);
            if (currentStepIndex === 0) {
                backStageHandler(quotation);
            }
        });
    };

    return (
        <>
            <ScenarioHeader title={strings.greenCardScrnarioHeader}/>

            {step.forms.map(form => {
                return React.createElement(forms[form.code], {
                    key: form.code,
                    onFormSubmit,
                    backStepHandler
                })
            })}
        </>
    );
};
